import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    iccid: '',
    notifyAlreadyRead: false,//是否已读公告（合作商登录时）
    showCheckstand: false, //收银台
    showCheckstandSource: "", //收银台订单来源页面
    isHeadquarterAppid: localStorage.getItem('isHeadquarterAppid')//是否是总部的微信公众号
  },
  mutations: {
    setIsHeadquarterAppid(state, str){
        state.isHeadquarterAppid = str;
    },
  },
  actions: {

  }
})
